<template>
  <span>{{completedAt}}</span>
</template>
<script>
  export default {
    props: ['at'],
    name: 'ba-build-completed-date',
    computed: {
      completedAt () {
        if (!this.at) {
          return '-'
        }
        return this.$moment(this.at).fromNow() + ' (' + this.$moment(this.at).format('YYYY-MM-DD HH:mm') + ')'
      },
    },
  }
</script>